import { defineStore } from "pinia";
import i18n from "../i18n";
import { DEFAULT_LOCALE, normalizeLocale } from "@/utils/localeUtils.js";

// Helper function to update HTML lang attribute
const updateHtmlLang = (locale) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = locale;
  }
};

export const useLanguageStore = defineStore("language", {
  state: () => {
    const savedLocale = normalizeLocale(localStorage.getItem("locale"));
    // Set initial HTML lang attribute
    updateHtmlLang(savedLocale);

    return {
      locale: savedLocale,
      localeBeforeEvent: null
    };
  },

  actions: {
    setLocale(locale) {
      this.locale = locale;
      localStorage.setItem("locale", locale);

      // Update i18n locale
      i18n.global.locale.value = locale;

      // Update HTML lang attribute
      updateHtmlLang(locale);
    },

    applyEventLocale(locale) {
      if (this.localeBeforeEvent === null) {
        this.localeBeforeEvent = this.locale;
      }
      this.setLocale(locale);
    },

    restoreLocaleAfterEvent() {
      if (this.localeBeforeEvent !== null) {
        this.setLocale(this.localeBeforeEvent);
        this.localeBeforeEvent = null;
      }
    }
  },

  getters: {
    currentLocale: (state) => state.locale,
    isEstonian: (state) => state.locale === "et",
    isEnglish: (state) => state.locale === "en"
  }
});
